import { FormOption } from '../../models/form-option.interface';
import { ToFormOptionConfig } from '../../models/to-form-option-config.interface';

/**
 * Formats iterable to FormOption Array
 *
 * ### Parameters
 * @param {selectValue} selectValue
 * Property used to set value of FormOption.
 * Can either be a key of entity or a mutation function
 *
 * @param {selectLabel} selectValue
 * Property used to set value of FormOption.
 * Can either be a key of entity or a mutation function
 *
 * ### Returns
 * @return FormOption[]
 */
export function formatFormOption<T>(
  entities?: T[],
  config?: ToFormOptionConfig<T>,
): FormOption[] {
  if (!entities || !Array.isArray(entities)) {
    return [];
  }
  return entities.map((entity: T) => {
    if (!entity || typeof entity !== 'object') {
      return {
        value: entity,
        label: `${entity}`,
      };
    }

    let value: string | number | boolean | T = entity['value' as never];
    let label: string = entity['label' as never];

    if (typeof config?.selectValue == 'string') {
      value = entity[config.selectValue as keyof T] as unknown as
        | string
        | number
        | boolean;
    } else if (typeof config?.selectValue == 'function') {
      value = config.selectValue(entity);
    }

    if (typeof config?.selectLabel == 'string') {
      label = entity[config.selectLabel as keyof T] as unknown as string;
    } else if (typeof config?.selectLabel == 'function') {
      label = config.selectLabel(entity);
    }
    return {
      value,
      label,
    };
  });
}
